import styled from 'styled-components';

export default styled.div`
  padding-top: 1rem;
`;
